    <div class="bg-white pl-3 py-3 pr-0 verification-container verification-verified position-relative container-shadow d-flex justify-content-between align-items-center">
        <div class="w-75">
        <p class="paragraph-bold text-white">{{dataObj?.heading_text}}</p>
        <p class="paragraph text-white">{{dataObj?.description_text}}</p>
        </div>
        <img src="assets/themes/images/profile-verified-img.svg" width="200px" />
    </div>